import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=ed688b06"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports